// extracted by mini-css-extract-plugin
export default {"create-instant-survey-info-modal":"CreateInstantSurvey_create-instant-survey-info-modal__44POO"};